<script>
import { mapGetters, mapState, mapActions } from "vuex";

import dateMixin from "@/mixins/dateMixin";

import Loader from "@/components/_base/Loader";
import Tip from "@/components/_base/Tip";
import OrderOffer from "../ProfessionalOfferList/OrderOffer";

export default {
  mixins: [dateMixin],

  components: {
    Loader,
    Tip,
    OrderOffer
  },

  data() {
    return {
      orderOfferOpen: false,
      searchsTried: []
    };
  },

  methods: {
    ...mapActions("orderScheduler", ["setOrderOffer"]),

    currentSearchFields() {
      if (!this.sugestionSearch) {
        return;
      }

      const filtersHash = {
        date: this.dateSearch,
        initialHour: this.initialHourSearch,
        duration: this.durationSearch,
        professionalName: this.professionalNameSearch
      };

      if (!this.sugestionSearch.length) {
        return this.searchsTried.push("endereço");
      }

      this.searchsTried.push(
        this.formatText(this.sugestionSearch.map(filter => filtersHash[filter]))
      );
    },

    formatText(search) {
      if (!search || !search.length) {
        return "";
      }

      if (search.length === 1) {
        return search[0];
      }

      let originalSearch = "";

      search.forEach((filter, index) => {
        if (index === search.length - 1) {
          return (originalSearch += `  ${filter}`);
        }

        originalSearch += `${!index ? "" : ","} ${filter}`;
      });

      return originalSearch;
    },

    toogleOfferModal() {
      this.orderOfferOpen = !this.orderOfferOpen;
    },

    handleOrderProfessionalOrder() {
      this.toogleOfferModal();

      this.setOrderOffer();
    }
  },

  computed: {
    ...mapGetters("orderScheduler", [
      "date",
      "initialHour",
      "duration",
      "professionalName",
      "foundProfessionals",
      "missingRequiredFields"
    ]),
    ...mapState("orderScheduler", [
      "sugestionPreloader",
      "sugestionSearch",
      "orderOfferExpired"
    ]),

    originalSearch: function() {
      const search = []
        .concat(this.dateSearch)
        .concat(this.initialHourSearch)
        .concat(this.durationSearch)
        .concat(this.professionalNameSearch)
        .filter(filter => filter);

      return this.formatText.join(" ");
    },

    dateSearch: function() {
      return this.date && `dia ${this.convertDateObject(this.date, "DD/MM")}`;
    },

    initialHourSearch: function() {
      return this.initialHour && `às ${this.initialHour}h`;
    },

    durationSearch: function() {
      return this.duration && `com ${this.duration} horas de duração`;
    },

    professionalNameSearch: function() {
      return (
        this.professionalName &&
        `com o(a) profissional (${this.professionalName})`
      );
    },

    someSugestionSearchTried: function() {
      return this.sugestionSearch;
    },

    lastSearch: function() {
      return this.searchsTried[this.searchsTried.length - 1];
    }
  },

  watch: {
    sugestionSearch() {
      this.currentSearchFields();
    }
  },

  mounted() {
    this.currentSearchFields();
  }
};
</script>

<template>
  <div class="empty">
    <p class="info">Não encontramos profissionais disponíveis no dia, hora e/ou duração informado.</p>

    <p class="info-low">Crie uma oferta de limpeza para notificarmos os profissionais na sua cidade e encontrar algúem disponível.</p>

    <Tip type="alert" v-if="missingRequiredFields">É necessário informar o dia hora inicial e duração da limpeza para crar uma oferta</Tip>

    <button
      class="btn btn-pink order-offer"
      :disabled="missingRequiredFields"
      :class="{'btn-disabled': missingRequiredFields}"
      @click="toogleOfferModal"
    >
      <img src="/static/broadcast-tower-solid.svg" />
      <span>criar oferta de limpeza</span>
    </button>

    <OrderOffer v-if="orderOfferOpen" @closeOrderOfferModal="toogleOfferModal" @createOffer="handleOrderProfessionalOrder" />

    <div v-if="someSugestionSearchTried && !foundProfessionals">
      <p class="sugestion-search">
        Procurando profissionais em horários alternativos:
      </p>

      <div class="tries">
        <div v-for="(searchTry, index) in searchsTried" :key="index">
          <span :class="{ 'strikeout': index !== searchsTried.length - 1 || !sugestionPreloader && !foundProfessionals}">
            {{ searchTry }}
          </span>

          <Loader small v-if="index === searchsTried.length - 1 && sugestionPreloader" />
        </div>
      </div>
    </div>

    <div v-else-if="foundProfessionals">
      <p class="sugestion-search">Sugestão de profissionais em horários alternativos</p>

      <p class="sugestion-search-filter">({{ lastSearch }})</p>

      <p class="tip">Veja mais horários disponíveis na agenda do profissional.</p>
    </div>
  </div>
</template>

<style scoped>
.info {
  text-align: center;
  font-size: 14px;
  margin: 0;
  font-weight: 400;
  margin-bottom: 16px;
}

.info-low {
  text-align: center;
  font-size: 14px;
  margin: 0;
  font-weight: 300;
  margin-bottom: 16px;
}

b {
  color: #af006b;
  font-weight: 500;
}

.order-offer {
  width: 100%;
  height: 40px;
  margin: 16px 0px;
  display: flex;
  font-weight: 400;
  justify-content: center;
  align-items: center;
  color: #fff;
  background: #af006b;
  border-radius: 2px;
  font-size: 14px;
  cursor: pointer;
}

.order-offer > img {
  height: 24px;
  margin-right: 8px;
  filter: invert(100%) sepia(0%) saturate(13%) hue-rotate(292deg)
    brightness(106%) contrast(103%);
}

.suggestion-alert {
  text-align: center;
  font-size: 14px;
  position: relative;
  margin: 0;
  margin-top: 16px;
}

.suggestion-alert::before {
  width: 100px;
  height: 1px;
  position: absolute;
  top: -8px;
  left: calc(50% - 50px);
  content: "";
  background: #603285;
}

.tries {
  margin-top: 4px;
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.tries div {
  font-size: 14px;
  font-weight: 400;
  color: #af006b;
  display: flex;
  align-items: center;
}

.tries div span {
  margin: 2px 0;
  text-align: center;
}

.strikeout {
  text-decoration: line-through;
}

.tries div *:last-child {
  margin-left: 4px;
}

.sugestion-search {
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  margin-top: 32px;
  margin-bottom: 0;
  position: relative;
}

.sugestion-search::before {
  width: 100px;
  height: 1px;
  position: absolute;
  top: -16px;
  left: calc(50% - 50px);
  content: "";
  background: #603285;
}

.sugestion-search-filter {
  font-size: 12px;
  text-align: center;
  margin-top: 4px;
}

.sugestion-search b {
  color: #af006b;
}

.tip {
  font-size: 12px;
  font-weight: 400;
  color: #424242;
  text-align: center;
  width: 100%;
  margin-bottom: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Components/Scheduler/Steps/ProfessionalList/Empty.vue